(function ($) {
    //iFrame load auto heigh content
    $("iframe.autoheight").on('load', function () { $(this).height($(this).contents().outerHeight()); });

    $("document").ready(function () {
        $(".modal").on("show", function () {
            $("body").css("overflow", "hidden");
        }).on("hide", function () {
            $("body").css("overflow", "auto");
        });
    });
    
    $("document").on("focusin", ".SearchPanel > .searchtext", function () {
        $(this).parent().addClass("active");
    }).on("focusout", ".SearchPanel > .searchtext", function () {
        $(this).parent().removeClass("active");
    });

    jQuery.fn.exists = function () {
        return jQuery(this).length > 0;
    };
    jQuery.fn.idle = function (time) {
        var i = $(this);
        i.queue(function() {
            setTimeout(function() { i.dequeue(); }, time);
        });
    };
    jQuery.fn.isBound = function (type, fn) {
        var data = this.data("events")[type];
        if (data === undefined || data === null || data.length === 0) {
            return false;
        }
        return (-1 !== $.inArray(fn, data));
    };
    
    jQuery.fn.extend({
        scrollTo: function (speed, easing) {
            return this.each(function() {
                var targetOffset = $(this).offset().top - 30;
                $("html,body").animate({ scrollTop: targetOffset }, speed, easing);
            });
        }
    });
    $.fn.selectRange = function (start, end) {
        return this.each(function() {
            if (this.setSelectionRange) {
                this.focus();
                this.setSelectionRange(start, end);
            } else if (this.createTextRange) {
                var range = this.createTextRange();
                range.collapse(true);
                range.moveEnd("character", end);
                range.moveStart("character", start);
                range.select();
            }
        });
    };
})(jQuery);


function IsInternetExplorer() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
    }

    var trident = ua.indexOf("Trident/");
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
    }

    var edge = ua.indexOf("Edge/");
    if (edge > 0) {
       // IE 12 (aka Edge) => return version number
       return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
    }

    // other browser
    return false;
}

function ConvertTextToUmlaut(value) {
    value = value.replace(/&#228;/g, "ä");
    value = value.replace(/&#246;/g, "ö");
    value = value.replace(/&#252;/g, "ü");
    value = value.replace(/&#223;/g, "ß");

    value = value.replace(/&#196;/g, "Ä");
    value = value.replace(/&#214;/g, "Ö");
    value = value.replace(/&#220;/g, "Ü");
    return value;
}

function SearchInWikipedia(autor) {
    var value = GetSelectedText();
    if (value !== "") {
        window.open("http://de.wikipedia.org/wiki/Special:Search?search=" + escape(value), "_blank");
    } else if (autor !== "") {
        window.open("http://de.wikipedia.org/wiki/Special:Search?search=" + escape(autor), "_blank");
    } else {
        window.alert("Sie m\xFCssen erst einen Textbereich markieren!");
    }
}

function SearchExternSite(url, defaultValue) {
    var value = GetSelectedText();
    if (value !== 'undefined' && value !== "") {
        url = url.replace(/\[query\]/gi, escape(value));
        window.open(url, "_blank");
    } else if (defaultValue !== 'undefined' && defaultValue !== "") {
        url = url.replace(/\[query\]/gi, escape(defaultValue));
        window.open(url, "_blank");
    } else {
        window.alert("Sie m\xFCssen erst einen Textbereich markieren!");
    }
}

function GetSelectedText() {
    if (window.getSelection) {
        return window.getSelection().toString();
    } else if (document.getSelection) {
        return document.getSelection().toString();
    } else if (document.selection) {
        return document.selection.createRange().text;
    }
    return "";
}

var bbcode;
function GetFormatedBBCode(value) {
    value = encodeHtml(value);
    $.ajax({
        type: "POST",
        async: false,
        url: "../service/StringFormatService.ashx",
        data: "rawstring=" + value,
        success: function (data) {
            bbcode = data;
        }
    });

    if (bbcode === "") {
        return value;
    }
    if (/€/gi.test(bbcode)) {
        bbcode = bbcode.replace(/€/gi, "&#8364;");
    }
    return bbcode.replace("_self", "_blank");
}

function GetFormatedBBCodeMain(value) {
    value = encodeHtml(value);
    $.ajax({
        type: "POST",
        async: false,
        url: "service/StringFormatService.ashx",
        data: "rawstring=" + value,
        success: function (data) {
            bbcode = data;
        }
    });
    if (bbcode === "") {
        return value;
    }
    if (/€/gi.test(bbcode)) {
        bbcode = bbcode.replace(/€/gi, "&#8364;");
    }
    return bbcode.replace("_self", "_blank");
}

function encodeHtml(input) {
    input = input.replace("\n", "[br]");
    if (/€/gi.test(input)) {
        input = input.replace(/€/gi, "&#8364;");
    }
    var output = "";
    for (var i = 0; i < input.length; i++) {
        if (output !== "") output += ";";
        output += input.charCodeAt(i);
    }
    return output;
}

function Dec2Hex(decimal) {
    var hexChars = "0123456789ABCDEF";
    var a = decimal % 16;
    var b = (decimal - a) / 16;
    var hex = "" + hexChars.charAt(b) + hexChars.charAt(a);
    return hex;
}

function InsertBookmark(sender, datavalue, serviceurl) {
    var $link = $(sender);
    $link.html("<span class=''><i class='fa fa-spinner fa-pulse fa-fix-space'></i>Speichern...</span>");

    InsertBookmarkService(serviceurl, datavalue, function (data) {
        if (data.Success) {
            $link.fadeOut("fast", function () {
                $link.html(data.Text);
                $link.fadeIn("fast");
            });
            $link.attr("href", "user/favorites.aspx");
            $link.removeAttr("onclick");
        }
    });
    return false;
}

function InsertBookmarkDetail(linkButton, datavalue, serviceurl) {
    var $link = $(linkButton);
    $link.html("<span class='text-success'><i class='fa fa-spinner fa-pulse'></i></span>");

    InsertBookmarkService(serviceurl, datavalue, function (data) {
        if (data.Success) {
            $link.fadeOut("fast", function () {
                $link.html("<span class='text-success'><i class='fa fa-check-square-o'></i></span>");
                $link.fadeIn("fast");
            });
            $link.attr("href", "user/favorites.aspx");
            $link.removeAttr("onclick");
        }
    });
    return false;
}

function InsertBookmarkService(serviceUrl, dataValue, callback) {
    $.ajax({
        type: "POST",
        async: true,
        url: serviceUrl,
        data: "action=favoriteadd&data=" + dataValue,
        dataType: "json",
        success: function (data) {
            if (typeof callback == "function") {
                callback(data);
            }
        }
    });
}

function DeleteBookmark(sender, cellCopiesId, datavalue, serviceurl) {
    var $row = $(sender);
    var $cellCopiesRow = $(cellCopiesId);
    $row.backdrop({ text: "wird gelöscht", spinner: true });
    $cellCopiesRow.backdrop({ text: "wird gelöscht", spinner: true });

    window.setTimeout(function () {
        DeleteBookmarkService(serviceurl, datavalue, function (data) {
            $row.backdropClear();
            if (data.Success) {
                $("div", $row).slideUp("slow", function () {
                    $row.fadeOut("slow", function () {
                        $(this).remove();
                    });
                });
                $("td", $row).css("padding-top", "0px").css("padding-bottom", "0px");

                $("div", $cellCopiesRow).slideUp("slow", function () {
                    $cellCopiesRow.fadeOut("slow", function () {
                        $(this).remove();
                    });
                });
                $("td", $cellCopiesRow).css("padding-top", "0px").css("padding-bottom", "0px");


                $(".FavoriteLabelStatus").text(data.Count + " Medien in " + data.Text);

                if (data.Count <= 0) {
                    $("#DivGridviewResult").hide();
                    $(".DeleteAll").hide();
                    $(".FavoriteLabelStatus").text(data.Text + " ist leer!");
                }
            }
        });
    }, 500);

    return false;
}

function DeleteBookmarkService(serviceUrl, dataValue, callback) {
    $.ajax({
        type: "POST",
        async: true,
        url: serviceUrl,
        data: "action=favoritedelete&data=" + dataValue,
        dataType: "json",
        success: function (data) {
            if (typeof callback == "function") {
                callback(data);
            }
        }
    });
}

function SetBookmarkImageInMasterPage(result) {
    var splitted = result.spit("|");
    var bookmarkimage = splitted[1];
    $("#" + bookmarkimage).attr("src", "images/bookmark_ok.png");
    $("#" + bookmarkimage).attr("title", splitted[2]);
    $("#" + bookmarkimage).attr("onclick", redirectToFavoritePage);
}

function SetBookmarkImageInDetailPage(Result) {
    var ar = Result.split("|");
    var hlToolbarFav = document.getElementById(ar[3]);
    var bookmarkId = document.getElementById(ar[1]);
    var hyperlinkId = document.getElementById(ar[2]);
    bookmarkId.src = "images/bookmark_ok.png";
    bookmarkId.onclick = redirectToFavoritePage;
    bookmarkId.title = ar[5];
    hyperlinkId.innerHTML = ar[5];
    hyperlinkId.onclick = redirectToFavoritePage;
    hlToolbarFav.innerHTML = ar[4];
}

function redirectToFavoritePage() {
    window.location = "user/favorites.aspx";
    return false;
}

function ShowDeleteReservationModal(masterRow, detailRow, serviceUrl, reservationsResultFailedUrl) {
    $("#modalImageCover").attr("src", $(detailRow + " .thumbCoverImage").attr("src"));
    $("#modalAutor").html($(masterRow + " .autor").html());
    $("#modalTitle").html($(masterRow + " .title").html());
    $("#modalReservationDate").html($(masterRow + " .reservateDate").html());
    $("#modalReservationStatus").html($(detailRow + " .media-status").html());

    $("#modalReservationButtonOk").data("serviceUrl", serviceUrl);
    $("#modalReservationButtonOk").data("reservationsResultFailedUrl", reservationsResultFailedUrl);
    
    $("#modalReservationButtonOk").data("masterRow", masterRow);
    $("#modalReservationButtonOk").data("detailRow", detailRow);
    $("#removeReservationModal").modal("show");
    return false;
}

function DeleteReservation(sender) {

    var masterRow = $(sender).data("masterRow");
    var detailRow = $(sender).data("detailRow");
    var serviceUrl = $(sender).data("serviceUrl");
    var dataValue = $(detailRow + " input[type=hidden]:first").val();

    // show action spinner
    $(masterRow).addClass("reservationDeleteBackdrop");
    $(detailRow).addClass("reservationDeleteBackdrop").addClass("reservationDeleteBackdropImage");

    $("#removeReservationModal").modal("hide");
    var data = "action=reservationdelete&data=" + dataValue;
    var reservationsResultFailedUrl = $(sender).data("reservationsResultFailedUrl") + "?" + data + "&status=failed";

    $.ajax({
        type: "POST",
        async: true,
        url: serviceUrl,
        data: data,
        dataType: "json",
        success: function (data) {
            // hide action spinner
            $(masterRow).removeClass("reservationDeleteBackdrop");
            $(detailRow).removeClass("reservationDeleteBackdrop").removeClass("reservationDeleteBackdropImage");

            if (data.Success) {
                $(masterRow).fadeOut("slow");
                $(detailRow).fadeOut("slow");
                $("#mediaCount").text(data.Count);
                if (data.Count <= 0) {
                    $(".table").hide();
                }
                $("#removeStatusSuccess").show();
            } else {
                // in case of fail redirect to reload the page and present the new state 
                // reservated item will move from reservated not ready to reservated ready here
                window.location.replace(reservationsResultFailedUrl);
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // hide action spinner
            $(masterRow).removeClass("reservationDeleteBackdrop");
            $(detailRow).removeClass("reservationDeleteBackdrop").removeClass("reservationDeleteBackdropImage");

        }
    });
}

var insidepermapanel = false;
function DisplayPermaLinkPanel(linkId) {
    var pos = $("#" + linkId).position();
    var width = $("#" + linkId).width();
    var newLeft = (pos.left - $("#PermaPanel").outerWidth() - 5);
    if (pos.left < $("#PermaPanel").outerWidth()) {
        newLeft = 0
    }
    $("#PermaPanel").css({
        left: newLeft + "px",
        top: (pos.top - 20) + "px"
    });
    $("#PermaPanel").toggle();
}

function AddBookmark(url, title, comment) {
    if (window.sidebar) {
        window.sidebar.addPanel(title, url, comment);
    } else if (window.opera && window.print) {
        var elem = document.createElement("a");
        elem.setAttribute("href", url);
        elem.setAttribute("title", title);
        elem.setAttribute("rel", "sidebar");
        elem.click();
    } else if (document.all) {
        window.external.AddFavorite(url, title);
    }
}

function selectItemByValue(element, value) {
    if (element.options != null && element.options.length != null) {
        for (var i = 0; i < element.options.length; i++) {
            if (element.options[i].value === value) {
                element.options[i].selected = true;
                return;
            }
        }
        element.options[(element.options.length - 1)].selected = true;
    }
}

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function MatchImage(image, modalBody) {
    var imageWidth = image[0].naturalWidth;
    var imageHeight = image[0].naturalHeight;
    var bodyWidth = modalBody.width();
    var bodyHeight = modalBody.height();

    var xFactor = bodyWidth / imageWidth;
    var yFactor = bodyHeight / imageHeight;

    var newImageWidth;
    var newImageHeight;
    if (xFactor <= yFactor) {
        newImageWidth = imageWidth * xFactor * currentZoomFactor - 2;
        newImageHeight = imageHeight * xFactor * currentZoomFactor - 2;
        image.css('margin-top', (bodyHeight - newImageHeight) / 2 + 'px');
        var xMargin = (bodyWidth - newImageWidth) / 2;
        image.css('margin-left', xMargin + 'px');
    } else {
        newImageWidth = imageWidth * yFactor * currentZoomFactor - 2;
        newImageHeight = imageHeight * yFactor * currentZoomFactor - 2;
        image.css('margin-left', (bodyWidth - newImageWidth) / 2 + 'px');
        var yMargin = (bodyHeight - newImageHeight) / 2;
        if (yMargin > 0) {
            image.css('margin-top', yMargin + 'px');
        }
    }

    image.css('width', newImageWidth + 'px');
    image.css('height', newImageHeight + 'px');
    image.css('max-width', 'inherit');
}